import { MOCK_MATERIALS } from "../data";
import { inventoryState } from "../types/index";

export const initialState: inventoryState = {
    statusFilter: "ALL",
    materials: MOCK_MATERIALS,
    isLoading: false,
    error: ""
};